import { type ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface SettingsRowProps {
  icon?: ReactNode
  media?: ReactNode
  label: string
  value: ReactNode
  description?: ReactNode
  badges?: ReactNode
  action?: ReactNode
  className?: string
  'data-onboarding-target'?: string
}

export function SettingsRow({
  icon,
  media,
  label,
  value,
  description,
  badges,
  action,
  className,
  'data-onboarding-target': onboardingTarget,
}: SettingsRowProps) {
  return (
    <div
      data-onboarding-target={onboardingTarget}
      className={cn(
        'flex items-center gap-3.5 bg-card px-4 py-3.5',
        className,
      )}
    >
      {media ? (
        <div className="shrink-0">{media}</div>
      ) : icon ? (
        <div className="flex size-9 shrink-0 items-center justify-center rounded-full bg-muted/40 text-muted-foreground">
          {icon}
        </div>
      ) : null}

      <div className="min-w-0 flex-1">
        <p className="text-xs text-muted-foreground">{label}</p>
        <div className="mt-0.5 flex flex-wrap items-center gap-2">
          <span className="text-sm font-medium text-foreground">{value}</span>
          {badges}
        </div>
        {description ? (
          <p className="mt-0.5 text-xs text-muted-foreground">{description}</p>
        ) : null}
      </div>

      {action ? (
        <div className="flex shrink-0 items-center gap-2">
          {action}
        </div>
      ) : null}
    </div>
  )
}
